<template>
  <!-- The horoscope's own tune form (focus + length), moved out of
       PersonalHoroscope unchanged so the Altar's horoscope uses the same one. -->
  <div class="ph-settings" data-testid="horoscope-tune">
    <h3 class="ph-card-title">Tune the Focus of your Personalized Horoscope</h3>
    <label class="ph-field">Focus <span class="ph-optional">(optional)</span>
      <textarea class="ph-textarea" v-model="focusModel" rows="2"
                placeholder="love, a decision, work, healing…"></textarea>
    </label>
    <label class="ph-field">Length - {{ wordsModel }} words
      <input type="range" min="10" max="255" step="5" v-model.number="wordsModel" class="ph-range" />
    </label>
    <div class="ph-actions">
      <button class="ph-btn" :disabled="busy" @click="$emit('go')">
        {{ busy ? busyLabel : goLabel }}
      </button>
      <button class="ph-btn-ghost" @click="$emit('cancel')">Cancel</button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  focus: { type: String, default: '' },
  words: { type: Number, default: 60 },
  busy: { type: Boolean, default: false },
  goLabel: { type: String, default: 'Re-read my day' },
  busyLabel: { type: String, default: 'Reading…' },
})
const emit = defineEmits(['update:focus', 'update:words', 'go', 'cancel'])
const focusModel = computed({ get: () => props.focus, set: (v) => emit('update:focus', v) })
const wordsModel = computed({ get: () => props.words, set: (v) => emit('update:words', v) })
</script>

<style scoped>
.ph-settings { display: flex; flex-direction: column; gap: 14px; padding-right: 34px; color: #e9dcff; text-align: left; }
.ph-card-title { font-family: 'Cinzel', serif; font-size: 18px; color: #f5e8c0; margin: 0 0 6px; }
.ph-field { display: flex; flex-direction: column; gap: 5px; font-size: 12px; color: #9b86c9; }
.ph-optional { color: #7c6ba0; font-weight: 400; }
.ph-textarea { margin-top: 2px; padding: 9px 11px; border-radius: 8px; border: 1px solid rgba(155,134,201,0.4);
  background: rgba(20,8,40,0.55); color: #e9dcff; font-size: 14px; font-family: inherit; resize: vertical; }
.ph-textarea::placeholder { color: #8a78ad; }
.ph-range { -webkit-appearance: none; appearance: none; width: 100%; height: 4px; border-radius: 999px;
  background: rgba(155,134,201,0.35); outline: none; margin-top: 6px; }
.ph-range::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 16px; height: 16px;
  border-radius: 50%; background: #C3A9FF; cursor: pointer; box-shadow: 0 1px 4px rgba(0,0,0,0.4); }
.ph-range::-moz-range-thumb { width: 16px; height: 16px; border: none; border-radius: 50%; background: #C3A9FF; cursor: pointer; }
.ph-actions { display: flex; gap: 10px; margin-top: 12px; flex-wrap: wrap; justify-content: center; }
.ph-btn { background: linear-gradient(180deg, #7b4bb0, #4e2776); color: #fff; border: none; border-radius: 999px; padding: 11px 22px; font-size: 14px; font-weight: 700; cursor: pointer; box-shadow: 0 8px 20px -10px rgba(78,39,118,0.9); }
.ph-btn:disabled { opacity: 0.55; cursor: default; }
.ph-btn-ghost { background: transparent; color: #9b86c9; border: 1px solid rgba(155,134,201,0.4); border-radius: 999px; padding: 10px 16px; font-size: 13px; cursor: pointer; }
</style>
